import React, {useState} from 'react';
import {FormattedMessage} from "react-intl";
import {Popover} from "antd";

interface CompetenceSwitchProps {
    possibleFilters: any,
    filtersSelected: any,
    setFiltersSelected: React.Dispatch<React.SetStateAction<any>>,
    setReload: React.Dispatch<React.SetStateAction<boolean>>,
}

const CompetenceSwitch: React.FC<CompetenceSwitchProps> = ({possibleFilters, filtersSelected, setFiltersSelected, setReload}) => {
    const [isOpen, setIsOpen] = useState(false);
    const selectedCompetence = filtersSelected.competences ?? 'all';

    const selectCompetence = (key: string) => {
        setFiltersSelected((filtersSelected:any) => ({ ...filtersSelected, competences: key === 'all' ? undefined : key}));
        setReload(true);
        setIsOpen(false);
    };

    const PopoverContent = () => {
        return (
            <>
                {
                    Object.entries(possibleFilters.competences).map((values:any, key) => {
                        if (values[0] !=selectedCompetence) {
                            return (
                                <div key={values[0]} className='select-item' onClick={() => selectCompetence(values[0])}><FormattedMessage id={values[1]} /></div>
                            )
                        }
                    })
                }
            </>
        )
    };

    return <div>
        <Popover
            placement='bottom'
            content={<PopoverContent />}
            overlayClassName='session-switch-popover'
            arrowContent={false}
            open={isOpen}
            trigger='click'
            onOpenChange={() => setIsOpen(!isOpen)}
        >
            <div className='filter-switch'>
                <span>
                    {possibleFilters.competences[selectedCompetence]}
                </span>
                <i className='fal fa-chevron-down' style={{fontSize: 10}} />
            </div>
        </Popover>
    </div>
}

export default CompetenceSwitch;
